<template>
  <d2-container>
    <template slot="header">
      <el-select
        @keyup.enter.native="getSearch"
        v-model="listQuery.status"
        clearable
        placeholder="请选择状态"
        size="small"
        style="margin-top:5px;margin-right: 20px;"
      >
        <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button @click="getSearch" class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
    </template>
    <el-button
      class="filter-item"
      v-permission:function="['CommissionRelate:btn_add']"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="getAdd"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="themeData"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="标题">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="副标题">
        <template slot-scope="scope">
          <span>{{ scope.row.subtitle }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="活动名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="背景图片">
        <template slot-scope="scope">
          <img :src="scope.row.backImg" style="width:80px;height:80px;object-fit: cover" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="限制参与证书">
        <template slot-scope="scope">
          <span>{{ scope.row.limitCert }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="兑换比例-成长币">
        <template slot-scope="scope">
          <span>{{ scope.row.convertibleGrowing}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="兑换比例-机会券">
        <template slot-scope="scope">
          <span>{{ scope.row.convertibleTicket}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="机会券名称">
        <template slot-scope="scope">
          <span>{{ scope.row.ticketName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="机会券图标">
        <template slot-scope="scope">
          <img :src="scope.row.ticketIcon" style="width:80px;height:80px;object-fit: cover" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <span
            style="background-color: #45B6AF;color: #fff;padding: 1px 4px;"
          >{{ scope.row.status == 0 ? '未开始' : scope.row.status == 1 ? '进行中' : scope.row.status == 2 ? '已结束' : '已关闭'}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="开始时间">
        <template slot-scope="scope">
          <span>{{ scope.row.startTime}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="结束时间">
        <template slot-scope="scope">
          <span>{{ scope.row.endTime}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="220">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="editCard(scope.row.id)"
            style="margin-top: 10px;"
            v-permission:function="['CommissionRelate:btn_edit']"
          >编辑</el-button>
          <span v-if="scope.row.status != 3">
            <el-button
              size="mini"
              type="danger"
              @click="offTheShelf(scope.row.id)"
              v-permission:function="['CommissionRelate:btn_off']"
              style="margin-top: 10px;"
            >关闭</el-button>
          </span>
          <span v-if="scope.row.status == 3">
            <el-button
              size="mini"
              type="success"
              v-permission:function="['CommissionRelate:btn_put']"
              @click="putOnTheShelf(scope.row.id)"
              style="margin-top: 10px;"
            >开启</el-button>
          </span>
          <el-button
            size="mini"
            type="info"
            @click="getCopy(scope.row.id)"
            v-permission:function="['CommissionRelate:btn_copy']"
            style="margin-top: 10px;"
          >复制</el-button>
          <el-button
            size="mini"
            type="success"
            v-permission:function="['CommissionRelate:btn_stock']"
            @click="getInfo(scope.row.id)"
            style="margin-top: 10px;"
          >卡片库存</el-button>
          <el-button
            size="mini"
            type="primary"
            v-permission:function="['CommissionRelate:btn_draw']"
            @click="getRecord(scope.row.id)"
            style="margin-top: 10px;"
          >抽奖测试</el-button>
          <el-button
            size="mini"
            type="primary"
            v-permission:function="['CommissionRelate:btn_exel']"
            @click="getExel(scope.row.id)"
            style="margin-top: 10px;"
          >导出卡片列表</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="抽奖" :visible.sync="dialogVisible" width="94%" :before-close="getClosed">
      <el-input
        clearable
        @keyup.enter.native="getLsist"
        style="width: 200px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入抽奖次数"
        size="small"
        v-model="form.count"
      ></el-input>
      <el-button @click="getLsist" class="filter-item" type="primary" icon="search" size="small">抽奖</el-button>
      <el-table
        size="small"
        :key="tableKey"
        stripe
        border
        highlight-current-row
        style=" margin-top: 20px"
        :data="lotteryTestList"
        v-loading="listLoading"
      >
        <el-table-column align="center" label="序号" type="index" width="100" ></el-table-column>
        <el-table-column align="center" label="id">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="类型">
          <template slot-scope="scope">
            <span>{{ scope.row.type }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="卡片名称">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="酬劳">
          <template slot-scope="scope">
            <span>{{ scope.row.reward }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="领取概率">
          <template slot-scope="scope">
            <span>{{ scope.row.probability }}%</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="当前概率">
          <template slot-scope="scope">
            <span>{{ scope.row.currentProbability }}%</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="等级">
          <template slot-scope="scope">
            <span v-if="scope.row.subGrade == 0">N</span>
            <span v-if="scope.row.subGrade == 1">R</span>
            <span v-if="scope.row.subGrade == 2">SR</span>
            <span v-if="scope.row.subGrade == 3">SSR</span>
            <span v-if="scope.row.subGrade == 4">ER</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="子等级">
          <template slot-scope="scope">
            <span v-if="scope.row.grade == 0">普通级</span>
            <span v-if="scope.row.grade == 1">学徒级</span>
            <span v-if="scope.row.grade == 2">精英级</span>
            <span v-if="scope.row.grade == 3">专家级</span>
            <span v-if="scope.row.grade == 4">大师级</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="打卡活动id">
          <template slot-scope="scope">
            <span>{{ scope.row.clockThemeId }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="委托方名称">
          <template slot-scope="scope">
            <span>{{ scope.row.companyName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="委托方图标">
          <template slot-scope="scope">
            <img :src="scope.row.companyIcon" alt style="width:30px;height:30px" />
          </template>
        </el-table-column>
        <el-table-column align="center" label="奖品可抽取份数">
          <template slot-scope="scope">
            <span>{{ scope.row.limitCount }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="实际已抽取数量">
          <template slot-scope="scope">
            <span>{{ scope.row.drawCount }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="开启动态概率">
          <template slot-scope="scope">
            <span>{{ scope.row.dynamicProbability == 1 ?'是':'否' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="getClosed">取 消</el-button>
      </span>
    </el-dialog>
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="width:500px"
      ></el-pagination>
    </template>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  getCRList,
  getCrUp,
  getCRDown,
  getCard,
  getStock,
  getCardExel
} from '@/api/demo/CommissionRelate/index'
import { getAppoints } from '@/api/demo/lotteryTest/index'
import { certList } from '@/api/demo/close/index'
import { exportExcel } from '@/api/demo/order/util'
export default {
  name: 'CommissionRelate',
  computed: {
    ...mapGetters(['elements'])
  },
  data () {
    return {
      commodityManager_btn_add: false,
      commodityManager_btn_edit: false,
      commodityManager_btn_off: false,
      commodityManager_btn_put: false,
      commodityManager_btn_copy: false,
      CommissionRelate_btn_stock: false,
      CommissionRelate_btn_draw: false,
      CommissionRelate_btn_exel: false,
      lotteryTestList: [],
      tableKey: 0,
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        status: null
      },
      themeData: [], // 活动列表
      total: null,
      statusList: [
        { id: 0, name: '未开始' },
        { id: 1, name: '进行中' },
        { id: 2, name: '已结束' },
        { id: 3, name: '已关闭' }
      ],
      listLoading: true, // 加载圈圈
      dialogVisible: false,
      lotteryTestId: '',
      form: {
        count: '',
        id: ''
      },
      certIdList: [], // 参与证书
      rules: {
        count: [
          { required: true, message: '请输入数量' },
          { type: 'number', message: '可发起次数必须为数字值' },
          {
            pattern: /^\+?[1-9][0-9]*$/,
            message: '请输入大于0的整数',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    $route (to, from) {
      this.getList()
    }
  },
  created () {},
  mounted () {
    this.getList()
  },
  methods: {
    // 活动列表
    getList (val) {
      let that = this
      if (val) {
        that.listQuery.currentPage = val
      } else {
        that.listQuery.currentPage = 1
      }
      certList(that.listQuery).then(res1 => {
        that.certIdList = res1.records
      })
      this.$nextTick(() => {
        getCRList(that.listQuery).then(res => {
          that.listLoading = true
          res.records.map(item => {
            let limitCerts = []
            let dd = JSON.parse(item.limitCert)
            that.certIdList.forEach(items => {
              dd.forEach(item1 => {
                if (item1 == items.id) {
                  return limitCerts.push(items.name)
                }
              })
            })
            item.limitCert = limitCerts.join(',')
          })
          this.$nextTick(function () {
            that.themeData = res.records
          })
          that.total = parseInt(res.total)
          that.listLoading = false
        })
      })
    },
    // 搜索
    getSearch () {
      let that = this
      that.getList(1)
    },
    // 添加
    getAdd () {
      this.$router.push({
        path: '/demo/CommissionRelate/addToCR'
      })
    },
    // 编辑
    editCard (id) {
      this.$router.push({
        path: '/demo/CommissionRelate/addToCR',
        query: {
          id: id
        }
      })
    },
    // 复制
    getCopy (id) {
      this.$router.push({
        path: '/demo/CommissionRelate/addToCR',
        query: {
          id: id,
          name: '复制'
        }
      })
    },
    // 下架
    offTheShelf (id) {
      let that = this
      getCRDown(id).then(res => {
        that.getList()
        that.$message({
          type: 'success',
          message: '下架成功!'
        })
      })
    },
    // 上架
    putOnTheShelf (id) {
      let that = this
      getCrUp(id).then(res => {
        that.getList()
        that.$message({
          type: 'success',
          message: '上架成功!'
        })
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getList(val)
    },
    // 详情
    getInfo (id) {
      let that = this
      that.$router.push({
        path: '/demo/CommissionRelate/delegationDetails',
        query: {
          id: id
        }
      })
    },
    // 记录列表
    getRecord (id) {
      let that = this
      that.dialogVisible = true
      that.form.id = id
    },
    getLsist () {
      let that = this
      that.listLoading = true
      getAppoints(that.form).then(res => {
        that.lotteryTestList = res
        that.listLoading = false
      })
    },
    getClosed () {
      let that = this
      that.dialogVisible = false
      that.form.id = ''
      that.form.count = ''
      that.lotteryTestList = []
    },
    // 导出卡片列表
    getExel (id) {
      let that = this
      getCardExel(id).then(res => {
        exportExcel(res, '卡片列表.xlsx')
      })
    }
  }
}
</script>

<style scoped>
.demo-table-expand2 {
  font-size: 0;
  padding: 50px;
}
.demo-table-expand {
  font-size: 0;
  padding: 1px;
  padding-left: 50px;
  padding-right: 50px;
  /* padding-bottom: 50px; */
}
.demo-table-expand:last-child {
  padding-bottom: 50px;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand2 label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 24%;
  color: #000;
  background: #ebf1f6;
  padding-left: 30px;
  margin-bottom: 0px;
  margin-right: 10px;
}
.demo-table-expand2 .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 22%;
  color: #000;
  background: #ebf1f6;
  padding-left: 30px;
  margin-bottom: 0px;
  margin-right: 10px;
}
.GG {
  display: flex;
}
/deep/.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
  /* text-align: center; */
}
</style>
